module.exports = __webpack_public_path__ + "static/media/planetary-reviving-station.b381d6c7.jpg";